export var asepticProcedures: Array<any> = [
  {
    id: 1,
    value: "OBSERVATION.VENTILATION_1", //"Ventilation"
    checked: true
  },
  {
    id: 2,
    value: "OBSERVATION.PREPARATION_IV_MEDICATION_2", //"Preparation of IV medication"
    checked: true
  },
  {
    id: 3,
    value: "OBSERVATION.MANIPULATION_IV_OR_IA_ACCESSES_1", //"Manipulation IV / IA accesses"
    checked: true
  },
  {
    id: 4,
    value: "OBSERVATION.CHANGE_DRESSING_OR_MANIPULATION_DRAINAGE_1", //"Change of dressing / manipulation of drainage"
    checked: true
  },
  {
    id: 5,
    value: "OBSERVATION.PUNCTURES_OR_INSERTION_IV_1", //"Punctures / insertion of IV line"
    checked: true
  },
  {
    id: 6,
    value: "OBSERVATION.MUCOUSE_MEMBRANES_CONTACT_1",  //"Contact with mucouse membranes"
    checked: true
  },
  { id: 7,
    value: "OBSERVATION.NOT_SPECIFIED", //"Not specified"
    checked: true
  },
]

export var fiveMomentsMap: Array<any> = [
  {
    key: 'beforeTouchingPatient',
    short: 'EVALUATION.BEF_PAT', //'bef. pat.',
    abbr: 'EVALUATION.BEF_PAT_ABBR', //'bef. pat.',
    name: 'OBSERVATION.BEFORE.TOUCHING_PATIENT', //'Before touching a patient'
    checked: true,
    index: 0
  },
  {
    key: 'beforeAsepticProcdures',
    dashboardKey: 'beforeAsepticProcedures',
    short: 'EVALUATION.BEF_ASEPT', //'bef. aspet.',
    abbr: 'EVALUATION.BEF_ASEPT_ABBR', //'bef. aspet.',
    name: 'OBSERVATION.BEFORE.ASEPTIC_PROCEDURES_1', //'Before aseptic procedures'
    checked: true,
    index: 1
  },
  {
    key: 'afterBodyFluidExposure',
    short: 'EVALUATION.AFT_B_F', //'aft.b.f.',
    abbr: 'EVALUATION.AFT_B_F_ABBR', //'aft.b.f.',
    name: 'OBSERVATION.AFTER.BODY_FLUID_EXPOSURE_RISK', //'After body fluid exposure risk'
    checked: true,
    index: 2
  },
  {
    key: 'afterTouchingPatient',
    short: 'EVALUATION.AFT_PAT', //'aft. pat.',
    abbr: 'EVALUATION.AFT_PAT_ABBR', //'aft. pat.',
    name: 'OBSERVATION.AFTER.TOUCHING_PATIENT', //'After touching a patient'
    checked: true,
    index: 3
  },
  {
    key: 'afterTouchingPatientSurroundings',
    short: 'EVALUATION.AFT_P_SUR', //'aft.p.sur.',
    abbr: 'EVALUATION.AFT_P_SUR_ABBR', //'aft.p.sur.',
    name: 'OBSERVATION.AFTER.TOUCHING_SURROUNDINGS', //'After touching patient surroundings'
    checked: true,
    index: 4
  }
];
// export function fiveMomentsUsingKeys(shortName,key){
//   if(shortName != 0)
//     return fiveMomentsMap.find(res=>res[key] == shortName);
//   return null;
// }

// export function asepticproceduresValue(asepticActionId){
//   if(asepticActionId != 0)
//     return asepticprocedures.find(res=>res.id == asepticActionId).value;
//   return null;
// }
